import { useEffect, useRef, useState } from 'react'

/** Whether a sticky header is stuck: the sentinel just above it has scrolled under its `top`. */
export const useStuck = (active: boolean) => {
  const sentinel = useRef<HTMLDivElement>(null)
  const header = useRef<HTMLDivElement>(null)
  const [stuck, setStuck] = useState(false)
  useEffect(() => {
    const element = sentinel.current
    if (!active || !element || typeof IntersectionObserver === 'undefined')
      return
    const offset = header.current
      ? parseFloat(getComputedStyle(header.current).top) || 0
      : 0
    const observer = new IntersectionObserver(
      ([entry]) => setStuck(!!entry && !entry.isIntersecting),
      { rootMargin: `-${offset}px 0px 0px 0px` }
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [active])
  return { sentinel, header, stuck: active && stuck }
}
